require.config({
  baseUrl: '/',
  paths: {
    jquery: 'vendor/jquery/jquery.min',
    Cookie: 'vendor/jquery.coockie/jquery.cookie',
    bootstrap: 'vendor/bootstrap/js/bootstrap.min',
    bootstrap_slider: 'vendor/bootstrap-slider/bootstrap-slider.min',
    bootstrap_toggle: 'vendor/bootstrap-toggle/bootstrap-toggle.min',
    transfercontroller: 'scripts/transfercontroller/transfercontroller'
  },
  shim: {
    jquery: {
      exports: 'jQuery'
    },

    bootstrap: {
      deps: ['jquery']
    },
    bootstrap_toggle: {
      deps: ['jquery']
    }
  }
});

require(['bootstrap', 'bootstrap_slider', 'bootstrap_toggle', 'transfercontroller'], function(bootstrap, slider, toggle, transfercontroller) {
  var app = new transfercontroller();
  window.app = app;
  app.initAcrossSlider();
  app.initAlongSlider();
  app.initPingSlider();
  app.initNumdispSlider();
  //app.initSideScanSlider();
  app.initPosSlider();
  //app.initRtDepthUploader();
  app.initTerrainUploader();
  //app.initKognifaiUploaders();
  app.updateFields();
  app.initKillSwitch();
  $('[data-toggle="tooltip"]').tooltip();
});